<template>
    <component :is="isDownload ? 'a' : 'router-link'"
               :to="link"
               :href="link"
               :target="isDownload ? '_blank' : 'self'"
               class="content-preview"
               :class="{'is-link': link}"
               v-if="link"
    >
        <div class="content-preview">
            <div class="content-preview__image">
                <figure class="image is-square has-border">
                    <LazyLoadedImage :src="imgSrc" alt="Beitragsbild"></LazyLoadedImage>
                </figure>
            </div>
            <div class="box has-background-primary-dark content-preview__box pb-6 pt-5  hyphenate">
                <div class="subtitle has-text-light is-uppercase" style="margin-bottom: 0px">{{category}}</div>
                <div class="divider has-background-grey-lighter mb-5"></div>
                <div class="title has-text-light is-size-3">{{title}}</div>
            </div>
        </div>
    </component>
    <div v-else class="container content-preview">
        <div class="content-preview__image">
            <figure class="image is-square has-border">
                <LazyLoadedImage :src="imgSrc" alt="Beitragsbild"></LazyLoadedImage>
            </figure>
        </div>
        <div class="box has-background-primary-dark content-preview__box pb-6 pt-5  hyphenate">
            <div class="subtitle has-text-light is-uppercase" style="margin-bottom: 0px">{{category}}</div>
            <div class="divider has-background-grey-lighter mb-5"></div>
            <div class="title has-text-light is-size-3">{{title}}</div>
        </div>
    </div>
</template>

<script>
    import LazyLoadedImage from "../shared/LazyLoadedImage";

    export default {
        name: "ContentPreview",
        components: {LazyLoadedImage},
        data() {
            return {}
        },
        props: {
            contentData: {
                type: Object,
                required: true
            }
        },
        computed: {
            imgSrc() {
                return this.contentData.content.gallery.rows[1].columns[1].publicUrl
            },
            title() {
                return this.contentData.content.header;
            },
            category() {
                return this.contentData.content.subheader;
            },
            link() {
                if(this.contentData.content.headerLink.url) {
                    if(this.contentData.content.headerLink.url.indexOf("fileadmin") !== -1) {
                        return `https://content.murtfeldt-as.de${this.contentData.content.headerLink.url}`
                    }

                    return this.contentData.content.headerLink.url;
                }
              return null;
            },
            isDownload(){
                return this.contentData.content.headerLink.url.indexOf("fileadmin") !== -1;
            }
        }
    }
</script>

<style lang="scss">
    .divider {
        width: 80%;
        height: 1px;
        margin: auto;
    }

    .cms-view__element {
        .content-preview {
            position: relative;
            max-width: 400px;
            min-height: 200px;
            height: auto;
            margin: 0 auto $size-1 * 5 auto;

            &__image {
                position: absolute;
                top: 0;
                width: 100%;

                img {
                    object-fit: cover;
                }
            }

            &__box {
                position: absolute;
                width: 65%;
                height: auto;
                bottom: -120%;
                left: 50%;
                -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
                text-align: center
            }

            &.is-link {
                .content-preview__image {
                    transition: all 100ms $easing;
                }

                .content-preview__box {
                    transition: all 170ms $easing;
                }

                &:hover {
                    cursor: pointer;
                    color: $text-light;

                    .content-preview__image {
                        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
                        transition: all 250ms $easing;
                    }

                    .content-preview__box {
                        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
                        transform: translate(-50%, -15px);
                        transition: all 170ms $easing;
                    }

                }
            }
        }
    }

    @media screen and (min-width: $desktop) {
        .cms-view__content {
            .cms-view__element.content-preview {
                width: 33%
            }
        }
    }
</style>